export enum ClickEventNameEnum {
  productTabSwitch = 'searchwidget_product_tab_switch',
  // originInputActivation = 'searchwidget_origin_input_activation',
  originTagRemoval = 'searchwidget_origin_tag_removal',
  originOptions = 'searchwidget_origin_options',
  // destinationInputActivation = 'searchwidget_destination_input_activation',
  destinationTagRemoval = 'searchwidget_destination_tag_removal',
  destinationOptions = 'searchwidget_destination_options',
  PaxSelectorOpen = 'searchwidget_pax_selector_open',
  calendarDepartureInputActivation = 'searchwidget_calendar_departure_input_activation',
  calendarReturnInputActivation = 'searchwidget_calendar_return_input_activation',
  calendarDepartureDatesSelection = 'searchwidget_calendar_departure_dates_selection',
  calendarReturnDatesSelection = 'searchwidget_calendar_return_dates_selection',
  calendarReturnTripLengthSliderSelection = 'searchwidget_calendar_return_tripLength_slider_selection',
  flightModeSwitch = 'searchwidget_flight_mode_switch',
  calendarExit = 'searchwidget_calendar_exit',
  datesTabSwitch = 'searchwidget_dates_tab_switch',
  searchButton = 'searchwidget_search_button',
  merchandisingBoxClick = 'merchandising_box_click',
  filtersCollapseClick = 'filters_collapse_click',
  filtersExpandClick = 'filters_expand_click',
  filtersResetClick = 'filters_reset_click',
  filtersSelectClick = 'filters_select_click',
  filtersRemovalClick = 'filters_removal_click',
  filtersSectionBudgetClick = 'filters_section_budget_click',
  sortClick = 'sort_click',
  sortInfoRecommendedHotelsLink = 'sort_info_recommended_hotels_link',
  sortInfoRecommendedHotelsPopupClose = 'sort_info_recommended_hotels_popup_close',
  showmapButton = 'showmap_button',
  showlistButton = 'showlist_button',
  cityDotClick = 'city_dot_click',
  cityMarkerHoveredClick = 'city_marker_hovered_click',
  cityMarkerSelectedViewAllDeals = 'city_marker_selected_view_all_deals',
  cityInfoboxViewAllDeals = 'city_infobox_view_all_deals',
  hotelDotClick = 'hotel_dot_click',
  hotelMarkerHoveredClick = 'hotel_marker_hovered_click',
  hotelCardCheckPriceButton = 'hotel_card_check_price_button',
  hotelCardClosureOutsideArea = 'hotel_card_closure_outside_area',
  zoomControllerClick = 'zoom_controller_click',
  destinationCardClick = 'destination_card_click',
  hotelCardClick = 'hotel_card_click',
  hotelCardImageGalleryClick = 'hotel_card_image_gallery_click',
  hotelCardTaxesClick = 'hotel_card_taxes_click',
  /* OPENX */

  // origin
  SearchwidgetOriginInputActivation = 'searchwidget_origin_input_activation',
  SearchwidgetOriginInputSelection = 'searchwidget_origin_input_selection',
  SearchwidgetOriginInputReset = 'searchwidget_origin_input_reset',
  SearchwidgetOriginBack = 'searchwidget_origin_back',
  SearchwidgetOriginTypedText = 'searchwidget_origin_typed_text',

  // destination
  SearchwidgetDestinationInputActivation = 'searchwidget_destination_input_activation',
  SearchwidgetDestinationInputSelection = 'searchwidget_destination_input_selection',
  SearchwidgetDestinationInputReset = 'searchwidget_destination_input_reset',
  SearchwidgetDestinationBack = 'searchwidget_destination_back',
  SearchwidgetDestinationTypedText = 'searchwidget_destination_typed_text',

  // calendar
  SearchwidgetCalendarInputActivation = 'searchwidget_calendar_input_activation',
  SearchwidgetCalendarDepartureDateSelection = 'searchwidget_calendar_departure_date_selection',
  SearchwidgetCalendarReturnDateSelection = 'searchwidget_calendar_return_date_selection',
  SearchwidgetCalendarPrevMonth = 'searchwidget_calendar_prev_month',
  SearchwidgetCalendarNextMonth = 'searchwidget_calendar_next_month',
  SearchwidgetCalendarAddDays = 'searchwidget_calendar_add_days',
  SearchwidgetCalendarBack = 'searchwidget_calendar_back',
  SearchwidgetCalendarDone = 'searchwidget_calendar_done',
  SearchwidgetCalendarToggle = 'searchwidget_calendar_toggle',

  // flexible calendar
  SearchwidgetFlexibleInputActivation = 'searchwidget_flexible_input_activation',
  SearchwidgetFlexibleTripLength = 'searchwidget_flexible_trip_length',
  SearchwidgetFlexibleTripPeriod = 'searchwidget_flexible_trip_period',

  // header collapsed
  SearchwidgetCollapsed = 'searchwidget_collapsed',

  SearchwidgetClose = 'searchwidget_close',

  // menu
  SearchwidgetMenu = 'searchwidget_menu',
  SearchwidgetMenuClose = 'searchwidget_menu_close',

  // cta
  SearchwidgetSearch = 'searchwidget_search',

  // header actions
  SearchwidgetLogo = 'searchwidget_logo',
  SearchwidgetHelp = 'searchwidget_help',
  SearchwidgetLogin = 'searchwidget_login',
  SearchwidgetLoginMyarea = 'searchwidget_login_myarea',

  // city card
  DestinationCard = 'destination_card',

  // dealsCard
  SearchresultsCard = 'searchresults_card',
  SearcgresultsCardCta = 'searchresults_card_cta',
  SearchresultsCardImage = 'searchresults_card_image',
  SearchresultsCardGalleryPrev = 'searchresults_card_gallery_prev',
  SearchresultsCardGalleryNext = 'searchresults_card_gallery_next',
  SearchresultsCardViewmore = 'searchresults_card_viewmore',
  SearchresultsCardAlternativeDate = 'searchresults_card_alternative_date',
  SearchresultsCardAlternativeDateGalleryPrev = 'searchresults_card_alternative_date_gallery_prev',
  SearchresultsCardAlternativeDateGalleryNext = 'searchresults_card_alternative_date_gallery_next',

  // sort
  SortButton = 'sort_button',

  // filters
  FiltersFreecancellation = 'filters_freecancellation',
  BookNowPayLater = 'filters_book_now_pay_later',
  FiltersWifi = 'filters_wifi',
  FiltersThreestars = 'filters_threestars',
  FiltersGuestrating = 'filters_guestrating',
  FiltersBlueFlag = 'filters_blue_flag',
  FiltersSustainabilityCertificate = 'filters_sustainability_certificate',
  FiltersBeachType = 'filters_beach_type',
  FiltersClimate = 'filters_climate',
  FiltersFauna = 'filters_fauna',
  FiltersWatersport = 'filters_watersport',
  FiltersEntertainments = 'filters_entertainments',
  FiltersWaterwaves = 'filters_waterwaves',

  FiltersFlashSales = 'filters_flash_sales',
  FiltersPinkPeople = 'filters_pinkpeople',
  FiltersPrice = 'filters_price',
  FiltersDirect = 'filters_direct',
  FiltersIand = 'filters_iand',
  FiltersLeisure = 'filters_leisure',
  FiltersHotelStars = 'filters_hotel_stars',
  FiltersMeal = 'filters_meal',
  FiltersRating = 'filters_rating',
  FiltersPropertytypes = 'filters_propertytypes',
  FiltersFacilities = 'filters_facilities',
  FiltersTsh = 'filters_tsh',

  FiltersClose = 'filters_close',
  FiltersReset = 'filters_reset',
  FiltersDone = 'filters_done',
  FiltersOpen = 'filters_open',

  MobileFiltersOpen = 'mobile_filters_open',

  // load more button
  DiscoverMore = 'discover_more',
  ShowMore = 'show_more',

  // map
  MapExpand = 'map_expand',
  MapMarker = 'map_marker',
  MapSearchMoving = 'map_search_moving',
  MapSearchArea = 'map_search_area',
  MapFiltersOpen = 'map_filters_open',
  MapShowList = 'map_show_list',
  MapShowMap = 'map_show_map',
  MapZoomIn = 'map_zoom_in',
  MapZoomOut = 'map_zoom_out',
  MapPanning = 'map_panning',

  // pagination
  SearchPaginationPrev = 'search_pagination_prev',
  SearchPaginationNext = 'search_pagination_next',
  SearchPaginationPage = 'search_pagination_page',

  // new facilities
  FiltersGeneralFacilities = 'filters_general_facilities_',
  FiltersFamilyFacilities = 'filters_family_facilities',
  FiltersActivityFacilities = 'filters_activity_facilities_',
  FiltersWellnessFacilities = 'filters_wellness_facilities',
  FiltersFoodFacilities = 'filters_food_facilities',
}
